if (!window.customElements.get('gift-card-recipient-form')) {
  class GiftCardRecipientForm extends HTMLElement {
    constructor() {
      super();
      this.buyBoxParent = this.closest('product-buybox');
      this.buyBoxSelectedVariantInput = this.buyBoxParent?.querySelector('[data-variant-id]');
      this.buyBoxSubmitButton = this.buyBoxParent?.querySelector('[data-submit-button]');
      this.form = this.querySelector('[data-gift-card-recipient-form]');
      this.formSubmitButton = this.querySelector('[data-gift-card-recipient-form-submit]');
      this.timezoneOffsetInput = this.querySelector('[data-gift-card-recipient-timezone-offset]');
      this.datepicker = this.querySelector('[data-datepicker]');
    }

    connectedCallback() {
      if (!this.buyBoxParent || !this.form || !this.buyBoxSubmitButton || !this.buyBoxSelectedVariantInput) {
        this.classList.add('hidden');
        return;
      }

      this.setTimezoneOffset();
      this.form.addEventListener('submit', (event) => this.submitForm(event));
      this.buyBoxParent.addEventListener('variantOptionsChanged', () => this.updateFormSubmitButton());
      this.initDatepicker();
    }

    initDatepicker() {
      if (!this.datepicker) return;

      new Datepicker(this.datepicker, {
        minDate: new Date(),
        format: 'yyyy-mm-dd',
        prevArrow: '<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 9L1 5L5 1" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        nextArrow: '<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 9L5 5L1 1" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      });
    }

    setTimezoneOffset() {
      if (!this.timezoneOffsetInput) return;
      this.timezoneOffsetInput.value = new Date().getTimezoneOffset().toString();
    }

    updateFormSubmitButton() {
      if (this.buyBoxSubmitButton.hasAttribute('disabled')) {
        this.formSubmitButton.setAttribute('disabled', '');
        this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-soldout-text');
      } else {
        this.formSubmitButton.removeAttribute('disabled');
        this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-available-text');
      }
    }

    submitForm(event) {
      event.preventDefault();

      this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-adding-text');
      this.formSubmitButton.setAttribute('disabled', '');
      this.formSubmitButton.setAttribute('aria-disabled', 'true');
      this.formSubmitButton.setAttribute('aria-busy', 'true');

      const formData = new FormData(this.form);
      const properties = {};

      formData.forEach((value, key) => {
        if (key.indexOf('properties') === -1) return;
        const formattedKey = key.replace('properties[', '').replace(']', '');
        properties[formattedKey] = value
      });

      const postBody = {
        items: [
          {
            id: this.buyBoxSelectedVariantInput.value,
            quantity: 1,
            properties
          }
        ]
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(postBody),
        credentials: 'same-origin'
      }).then((response) => {
        if (response.ok) {
          const sideCart = document.querySelector('side-cart');

          this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-success-text');

          this.buyBoxParent.updateCartBubbles();

          if (sideCart) {
            sideCart.renderContents();
          }

          this.formSubmitButton.removeAttribute('aria-busy');
          this.formSubmitButton.removeAttribute('disabled');
          this.formSubmitButton.removeAttribute('aria-disabled');

          setTimeout(() => {
            this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-available-text');

            if (sideCart) {
              sideCart.open();
            }
          }, 1500);
        } else {
          return response.json().then((err) => {
            console.error('Cart add error:', err);

            this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-error-text');

            setTimeout(() => {
              this.resetSubmitButton();
            }, 1500);
          });
        }
      }).catch((error) => {
        console.error(error);

        this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-error-text');

        setTimeout(() => {
          this.resetSubmitButton();
        }, 1500);
      })
    }

    resetSubmitButton() {
      this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-available-text');
      this.formSubmitButton.removeAttribute('aria-busy');
      this.formSubmitButton.removeAttribute('disabled');
      this.formSubmitButton.removeAttribute('aria-disabled');
    }
  }

  window.customElements.define('gift-card-recipient-form', GiftCardRecipientForm);
}